import type { GetEntitiesRequest } from '@backstage/catalog-client';

import { useApi } from '@backstage/frontend-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import stableStringify from 'json-stable-stringify';
import { useCallback } from 'react';

import { useCacheCallback } from './useCacheCallback';

export type GetEntitiesByFilterCallback = ReturnType<
  typeof useGetEntitiesByFilterCallback
>;

export const useGetEntitiesByFilterCallback = () => {
  const catalogApi = useApi(catalogApiRef);
  const requestCallback = useCallback(
    async (request: GetEntitiesRequest | null | undefined) => {
      if (!request) {
        return null;
      }
      let requestWithOrder = request;
      if (!requestWithOrder.order) {
        requestWithOrder = {
          ...request,
          order: [{ field: 'metadata.name', order: 'asc' }],
        };
      }
      const { items } = await catalogApi.getEntities(requestWithOrder);
      return items;
    },
    [catalogApi],
  );
  return useCacheCallback(
    requestCallback,
    {
      getCacheKey: request =>
        `useGetEntitiesByFilterCallback:${stableStringify(request)}`,
    },
    [requestCallback],
  );
};
